'use strict';

var _ = require('lodash');
var d3 = require('d3');

/**
 * Svg Pattern Service
 *
 * Provides svg pattern definition
 *
 * @param $location
 * @constructor
 */
var SvgPatternService = function SvgPatternService($location) {
  var patternsContainer = d3.select(document.querySelector('body')).append('svg').attr({
    'class': 'svg-pattern-container',
    'width': 0,
    'height': 0
  });

  /**
   * Holds IDs of already appended patterns
   * @type {Array}
   */
  var readyPatterns = [];

  /**
   * Available pattern definitions
   */
  var patternConstructors = {
    'gap-pattern': function gapPattern() {
      createStripedPattern(patternsContainer, 'gap-pattern');
    },
    'gap-pattern-viewport': function gapPatternViewport() {
      createStripedViewportPattern(patternsContainer, 'gap-pattern-viewport');
    },
    'noData-pattern': function noDataPattern() {
      createStripedPattern(patternsContainer, 'noData-pattern');
    },
    'noData-pattern-viewport': function noDataPatternViewport() {
      createStripedViewportPattern(patternsContainer, 'noData-pattern-viewport');
    },
    'user-exclusion': function userExclusion() {
      patternsContainer.append('pattern').attr({
        'id': 'user-exclusion',
        'width': 10,
        'height': 10,
        'patternUnits': 'userSpaceOnUse',
        'patternTransform': 'rotate(45)'
      }).append('rect').attr({
        'height': 20,
        'width': 5
      });
    },
    'user-exclusion-viewport': function userExclusionViewport() {
      patternsContainer.append('pattern').attr({
        'id': 'user-exclusion-viewport',
        'width': 6,
        'height': 2,
        'patternUnits': 'userSpaceOnUse',
        'patternTransform': 'rotate(45)'
      }).append('rect').attr({
        'height': 20,
        'width': 3
      });
    },
    'inactive-bar': function inactiveBar() {
      patternsContainer.append('pattern').attr({
        'id': 'inactive-bar',
        'width': 10,
        'height': 10,
        'patternUnits': 'userSpaceOnUse',
        'patternTransform': 'rotate(45)'
      }).append('rect').attr({
        'height': 20,
        'width': 5
      });
    }
  };

  /**
   * Returns pattern url
   * @param {string} patternId
   * @returns {string}
   */
  function getPatternUrl(patternId) {
    if (!_.includes(readyPatterns, patternId)) {
      initPattern(patternId);
    }
    return 'url(' + $location.path() + '#' + patternId + ')';
  }

  /**
   * Appends pattern to DOM
   * @param {string} patternId
   */
  function initPattern(patternId) {
    if (isPatternAvailable(patternId) && !_.includes(readyPatterns, patternId)) {
      readyPatterns.push(patternId);
      patternConstructors[patternId]();
    }
  }

  /**
   * Appends multiple patterns to DOM.
   *
   * Should be used in chart factory to pre-append patterns that will be used  in chart
   *
   * @param {string[]} [patterns] - array of patterns ID's that should be prepare. If not given, all patterns will be appended
   */
  function initPatterns(patterns) {
    if (_.isArray(patterns)) {
      _.forEach(patterns, function (patternId) {
        initPattern(patternId);
      });
    } else {
      _.forEach(patternConstructors, function (constructor, patternId) {
        initPattern(patternId);
      });
    }
  }

  /**
   * Used in Unit tests
   */
  function getAvailablePatterns() {
    return _.keys(patternConstructors);
  }

  /**
   * Check if given pattern exists
   * @param {string} patternId
   * @returns {boolean}
   */
  function isPatternAvailable(patternId) {
    return !!patternConstructors[patternId];
  }

  /**
   * Appends to container a striped pattern for bar charts
   * @param patternsContainer
   * @param patternId
   */
  function createStripedPattern(patternsContainer, patternId) {
    patternsContainer.append('pattern').attr({
      'id': patternId,
      'width': 10,
      'height': 10,
      'patternUnits': 'userSpaceOnUse',
      'patternTransform': 'rotate(45)'
    }).append('rect').attr({
      'height': 20,
      'width': 5
    });
  }

  /**
   * Appends to container a striped pattern for bar charts viewport
   * @param patternsContainer
   * @param patternId
   */
  function createStripedViewportPattern(patternsContainer, patternId) {
    patternsContainer.append('pattern').attr({
      'id': patternId,
      'width': 6,
      'height': 2,
      'patternUnits': 'userSpaceOnUse',
      'patternTransform': 'rotate(45)'
    }).append('rect').attr({
      'height': 20,
      'width': 3
    });
  }
  return {
    initPatterns: initPatterns,
    getPatternUrl: getPatternUrl,
    getAvailablePatterns: getAvailablePatterns,
    isPatternAvailable: isPatternAvailable
  };
};
SvgPatternService.$inject = ['$location'];
module.exports = SvgPatternService;